import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { QuizQuestionAnswer } from '@digilize/shared/definitions/src';

@Component({
  selector: 'lsl-text-exercise',
  templateUrl: './text-exercise.component.html',
  styleUrls: ['./text-exercise.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TextExerciseComponent implements OnInit {
  @Input() answerValidation: QuizQuestionAnswer;
  @Input() form: FormControl;

  constructor() {}

  ngOnInit() {}
}
